import React from 'react';
import mobile from '../assets/mobile.png';
import review from '../assets/review-star.png';
const ProductReview = () => {
    return (
        <div className='py-12'>
            <div className="container">
                <h2 className='text-2xl font-semibold text-black pb-3 border-b border-dashed mb-8'>Review your purchase</h2>
                <div className='search-items md:flex items-center gap-3'>
                    <div className="single-review px-4 border border-[#ddd] rounded-2xl md:pb-0 pb-5  md:flex mb-7 md:mb-0 items-center gap-3">
                        <img src={mobile} alt="" srcset="" />
                        <div className="single-content">
                            <p className='text-xl font-semibold mb-4'>iPhone 14 Pro Max with Apple M1 chip (6.7-inch/17.0 cm, 128GB)</p>
                            <p>you bought it at the best price </p>
                            <h4 className='text-xl font-semibold mb-4'>₹1,39,900.00</h4>
                            <img src={review} alt="" srcset="" />
                        </div>
                    </div>
                    <div className="single-review px-4 border border-[#ddd] rounded-2xl md:pb-0 pb-5 md:flex items-center gap-3">
                        <img src={mobile} alt="" srcset="" />
                        <div className="single-content">
                            <p className='text-xl font-semibold mb-4'>iPhone 14 Pro Max with Apple M1 chip (6.7-inch/17.0 cm, 128GB)</p>
                            <p>you bought it at the best price </p>
                            <h4 className='text-xl font-semibold mb-4'>₹1,39,900.00</h4>
                            <img src={review} alt="" srcset="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductReview;